import React from 'react';
import { PlusIcon } from '@heroicons/react/outline';
import CampaignSequenceForm from './CampaignSequenceForm';

const CampaignEditingSection = ({
	editingSequences,
	campaignSlug,
	maxSequences,
	onSequenceUpdate,
	onSequenceDelete,
	onAddSequence
}) => {
	return (
		<div className="bg-gray-50 rounded-b-lg">
			{/* Sequences */}
			{editingSequences.map((sequence, index) => (
				<CampaignSequenceForm
					key={sequence.id || `new-${index}`}
					sequence={sequence}
					index={index}
					onUpdate={onSequenceUpdate}
					onDelete={() => onSequenceDelete(index)}
					isNew={!sequence.id || sequence.id > 1000000000000}
					campaignSlug={campaignSlug}
				/>
			))}
			
			{/* Add More button - only show if less than MAX_SEQUENCES 
			     Note: Existing sequences from API are preserved even if > MAX_SEQUENCES,
			     but manual additions are limited to MAX_SEQUENCES total */}
			{editingSequences.length < maxSequences && (
				<button
					onClick={onAddSequence}
					className="bg-white text-blue-600 px-4 py-3 w-full text-sm font-medium hover:bg-gray-100 border-t border-gray-100 flex items-center justify-center gap-2 rounded-b-lg"
				>
					<PlusIcon className="w-4 h-4" />
					Add More + (Max {maxSequences})
				</button>
			)}
		</div>
	);
};

export default CampaignEditingSection; 